import { Controller } from "@hotwired/stimulus"

// Porta la pagina in cima con uno scorrimento morbido e si toglie: dopo un invito da una riga di Organizzazioni.js
// il link si vede nel riquadro in alto (window.scrollTo({ top: 0, behavior: "smooth" })).
export default class extends Controller {
  connect() {
    window.scrollTo({ top: 0, behavior: "smooth" })
    this.element.remove()
  }
}
